import { BaseUrl } from './ApiUrl'
import AXIOS_SERVICE from '../utils/AxiosUtil'

const AuthService = () => {}
AuthService.Login = async(payload)=> {  
 return await AXIOS_SERVICE('post', `${BaseUrl}/auth/login`, payload)
}

export default AuthService